import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Spin, Button, Tag, Progress ,Table,Modal} from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CourseDetailsInstructor() {
  const { id } = useParams();
 
   const navigate = useNavigate();

  // Auth info
  const token = localStorage.getItem("token");
  const fullName = localStorage.getItem("fullName");
  const role = (localStorage.getItem("role") || "").toUpperCase();

  useEffect(() => {
    if (!token || !fullName || !role) {
      navigate("/user/sign_in");
    }
  }, [token, fullName, role, navigate]);


  const [loading, setLoading] = useState(true);
  const [course, setCourse] = useState(null);
  const [courseAccess, setCourseAccess] = useState([]);
  const [searchEmail, setSearchEmail] = useState("");

  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);
const [selectedRole, setSelectedRole] = useState("");
const [availableUsers, setAvailableUsers] = useState([]);
const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    fetchCourse();
  }, []);

  const fetchCourse = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/course/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        setCourse(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };




  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" />
      </div>
    );
  }

  if (!course) return <div>Course not found</div>;

  const today = new Date();
  const start = new Date(course.BatchStartDate);
  const end = new Date(course.BatchEndDate);

  const status =
    start > today
      ? "UPCOMING"
      : end < today
      ? "COMPLETED"
      : "ACTIVE";

  const progress = course.CourseStatus;

  const statusColor =
    status === "ACTIVE"
      ? "green"
      : status === "UPCOMING"
      ? "blue"
      : "default";


      const students = courseAccess.filter(u => u.Role === "STUDENT");
const instructors = courseAccess.filter(u => u.Role === "INSTRUCTOR");
const operations = courseAccess.filter(u => u.Role === "OPERATIONS");



const roleEndpointMap = {
  STUDENT: "/course-access/assign-course-student",
  INSTRUCTOR: "/course-access/assign-course-instructor",
  OPERATIONS: "/course-access/assign-course-operations"
};
const handleSubmitAccess = async () => {
  try {

    if (!selectedRole) {
      toast.error("No role selected");
      return;
    }

    const endpoint = roleEndpointMap[selectedRole?.toUpperCase()];

    if (!endpoint) {
      toast.error("Invalid role selected");
      return;
    }

    if (!selectedRowKeys.length) {
      toast.error("Please select at least one user");
      return;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}${endpoint}`,
      {
        CourseName: course.CourseName,
        BatchName: course.BatchName,
        BatchType: course.BatchType,
        CourseTiming: course.CourseTiming,
        BatchStartDate: course.BatchStartDate,
        BatchEndDate: course.BatchEndDate,
        Emails: selectedRowKeys
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (response.data.success) {
      toast.success(
        response.data.message || "Access assigned successfully"
      );

      setIsAccessModalOpen(false);
      setSelectedRowKeys([]);

    } else {
      toast.error(
        response.data.message || "Failed to assign access"
      );
    }

  } catch (err) {
    console.error("Assign Access Error:", err.response?.data || err.message);

    toast.error(
      err.response?.data?.message || "Something went wrong while assigning access"
    );
  }
};

const filteredUsers = availableUsers.filter(user =>
  user.Email.toLowerCase().includes(searchEmail.toLowerCase())
);
 return (
  <div className="min-h-screen px-12 py-10 bg-white text-slate-200">
    
     <ToastContainer
                    position="bottom-left"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                    className="!mb-6 !ml-4"
                    toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                  />


  {/* ================= HERO SECTION ================= */}
<div className="relative p-12 overflow-hidden border shadow-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-xl border-white/10">

  {/* Glow Effects */}
  <div className="absolute top-0 left-0 w-40 h-40 bg-orange-500 rounded-full opacity-20 blur-3xl"></div>
  <div className="absolute bottom-0 right-0 w-40 h-40 bg-indigo-500 rounded-full opacity-20 blur-3xl"></div>

  <div className="relative flex items-center justify-between gap-16">

    {/* ================= LEFT CONTENT ================= */}
    <div className="flex-1">

      {/* Title */}
      <h1 className="text-3xl font-bold tracking-tight text-white">
        {course.CourseName}
      </h1>

      {/* Program */}
      <p className="mt-3 text-lg font-bold text-slate-400">
        {course.ProgramName}
      </p>

      {/* Status */}
      <div className="mt-6">
        <span
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold tracking-wide border backdrop-blur-md
          ${
            status === "ACTIVE"
              ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/20"
              : status === "UPCOMING"
              ? "bg-indigo-500/10 text-indigo-400 border-indigo-500/20"
              : "bg-slate-500/10 text-slate-400 border-slate-500/20"
          }`}
        >
          <span
            className={`w-2 h-2 rounded-full ${
              status === "ACTIVE"
                ? "bg-emerald-400"
                : status === "UPCOMING"
                ? "bg-indigo-400"
                : "bg-slate-400"
            }`}
          />
          {status}
        </span>
      </div>

      {/* CTA */}
      <div className="mt-12">
        <button
          onClick={() =>
            navigate(
              `/academy/mentor-dashboard/course/${course.CourseName}/course-content/modules`,
              {
                state: {
                  CourseName: course.CourseName,
                  BatchName: course.BatchName,
                  BatchType: course.BatchType,
                },
              }
            )
          }
          className="px-10 py-4 font-semibold text-white transition-all duration-300 shadow-lg rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 hover:scale-[1.03] hover:shadow-orange-500/30"
        >
          ⚙️ Manage Course Content
        </button>
         

      </div>

    </div>

    {/* ================= RIGHT IMAGE ================= */}
    <div className="relative w-[520px] h-[300px]] rounded-2xl overflow-hidden border border-white/10 shadow-lg group">

      {/* Image */}
      <img
        src={course.CourseImageUrl || "https://via.placeholder.com/420x260"}
        alt={course.CourseName}
        className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
      />

      {/* Overlay */}
      <div className="absolute inset-0 transition bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-80 group-hover:opacity-100"></div>

      {/* Optional label */}
      <div className="absolute px-3 py-1 text-xs font-semibold text-white rounded-md top-3 left-3 bg-black/60 backdrop-blur">
        Instructor Panel
      </div>

    </div>

  </div>
</div>



      {/* ================= ANALYTICS CARDS ================= */}
<div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2 xl:grid-cols-4">

  {/* Batch Name */}
  <div className="p-5 transition-all duration-300 border shadow-md bg-slate-700 backdrop-blur-lg rounded-2xl border-white/10 hover:shadow-xl hover:scale-[1.02]">
    <p className="text-xs font-semibold tracking-wide uppercase text-slate-400">
      Batch Name
    </p>
    <h3 className="mt-2 text-lg font-semibold text-white">
      {course.BatchName || "—"}
    </h3>
  </div>

  {/* Batch Type */}
  <div className="p-5 transition-all duration-300 border shadow-md bg-slate-700 backdrop-blur-lg rounded-2xl border-white/10 hover:shadow-xl hover:scale-[1.02]">
    <p className="text-xs font-semibold tracking-wide uppercase text-slate-400">
      Batch Type
    </p>
    <h3 className="mt-2 text-lg font-semibold text-white">
      {course.BatchType || "—"}
    </h3>
  </div>

  {/* Course Type */}
  <div className="p-5 transition-all duration-300 border shadow-md bg-slate-700 backdrop-blur-lg rounded-2xl border-white/10 hover:shadow-xl hover:scale-[1.02]">
    <p className="text-xs font-semibold tracking-wide uppercase text-slate-400">
      Course Type
    </p>
    <h3 className="mt-2 text-lg font-semibold text-white">
      {course.CourseType || "—"}
    </h3>
  </div>

  {/* Timing */}
  <div className="p-5 transition-all duration-300 border shadow-md bg-slate-700 backdrop-blur-lg rounded-2xl border-white/10 hover:shadow-xl hover:scale-[1.02]">
    <p className="text-xs font-semibold tracking-wide uppercase text-slate-400">
      Schedule
    </p>
    <h3 className="mt-2 text-lg font-semibold text-white">
      {course.CourseTiming || "—"}
    </h3>
  </div>

</div>

       {/* ================= TIMELINE SECTION ================= */}
<div className="relative p-10 mt-10 overflow-hidden border shadow-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-2xl border-white/10">

  {/* Glow Effects */}
  <div className="absolute top-0 left-0 w-32 h-32 rounded-full bg-emerald-500 opacity-20 blur-3xl"></div>
  <div className="absolute bottom-0 right-0 w-32 h-32 bg-indigo-500 rounded-full opacity-20 blur-3xl"></div>

  {/* Header */}
  <div className="relative mb-10">
    <h2 className="text-2xl font-bold tracking-tight text-white">
      Batch Timeline & Progress
    </h2>
    <p className="mt-1 text-sm text-slate-400">
      Track your batch duration and completion status
    </p>
  </div>

  {/* Grid */}
  <div className="relative grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-4">

    {/* START */}
    <div className="p-5 border bg-white/5 backdrop-blur-md rounded-xl border-white/10">
      <p className="text-xs font-semibold tracking-wide uppercase text-slate-400">
        Start Date
      </p>
      <p className="mt-2 text-lg font-semibold text-white">
        {formatDate(course.BatchStartDate)}
      </p>
    </div>

    {/* END */}
    <div className="p-5 border bg-white/5 backdrop-blur-md rounded-xl border-white/10">
      <p className="text-xs font-semibold tracking-wide uppercase text-slate-400">
        End Date
      </p>
      <p className="mt-2 text-lg font-semibold text-white">
        {formatDate(course.BatchEndDate)}
      </p>
    </div>

    {/* STATUS */}
    <div className="p-5 border bg-white/5 backdrop-blur-md rounded-xl border-white/10">
      <p className="text-xs font-semibold tracking-wide uppercase text-slate-400">
        Status
      </p>

      <div className="flex items-center gap-2 mt-2">
        <span
          className={`w-2.5 h-2.5 rounded-full ${
            status === "ACTIVE"
              ? "bg-emerald-400"
              : status === "UPCOMING"
              ? "bg-indigo-400"
              : "bg-slate-400"
          }`}
        />
        <span className="text-lg font-semibold text-white">
          {status}
        </span>
      </div>
    </div>

    {/* PROGRESS */}
    <div className="p-5 border bg-white/5 backdrop-blur-md rounded-xl border-white/10">
      <p className="text-xs font-semibold tracking-wide uppercase text-slate-400">
        Completion
      </p>

      {/* Progress Bar */}
      <div className="w-full h-3 mt-4 overflow-hidden rounded-full bg-slate-700/50">
        <div
          className={`h-full rounded-full transition-all duration-700 ${
            status === "ACTIVE"
              ? "bg-gradient-to-r from-emerald-400 to-emerald-600 shadow-[0_0_10px_rgba(16,185,129,0.6)]"
              : status === "UPCOMING"
              ? "bg-gradient-to-r from-indigo-400 to-indigo-600"
              : "bg-slate-500"
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>

      <p className="mt-3 text-sm font-medium text-slate-300">
        {progress}% completed
      </p>
    </div>

  </div>
</div>


    {/* ================= ACCESS CONTROL SECTION ================= */}
{/* <div className="mt-8 border shadow-xl bg-slate-700 p-7 border-slate-800 rounded-xl">

  <h2 className="mb-10 text-lg font-semibold tracking-wide text-white">
   COURSE ACCESS CONTROL
  </h2>

  <div className="grid grid-rows-3 gap-3">

    <AccessSection
      title="STUDENT"
      users={students}
      onDelete={handleDeleteUser}
       onAdd={handleOpenAccessModal}
     
    />

    <AccessSection
      title="INSTRUCTOR"
      users={instructors}
      onDelete={handleDeleteUser}
       onAdd={handleOpenAccessModal}
    
    />

    <AccessSection
      title="OPERATIONS"
      users={operations}
      onDelete={handleDeleteUser}
       onAdd={handleOpenAccessModal}
     
    />

  </div>

</div> */}

<Modal
  open={isAccessModalOpen}
  onCancel={() => {
    setIsAccessModalOpen(false);
    setSelectedRowKeys([]);
  }}
  footer={null}
  width={1100}
>

  {/* ================= HEADER ================= */}
  <div className="pb-6 border-b border-gray-900">

    <div className="flex items-center justify-between">

      <div>
        <h2 className="text-3xl font-bold tracking-tight text-indigo-900">
          Assign Course Access
        </h2>
        <p className="mt-1 text-base text-indigo-800">
          Grant access to{" "}
          <span className="font-bold text-red-700">
            {selectedRole}
          </span>{" "}
          users
        </p>
      </div>

      <div className="px-4 py-1 text-xs font-semibold text-white rounded-full shadow-sm bg-gradient-to-r from-indigo-600 to-violet-600">
        {selectedRowKeys.length} Selected
      </div>

    </div>

  </div>


  {/* ================= COURSE DETAILS ================= */}
  <div className="p-6 mt-6 border border-indigo-100 shadow-md rounded-2xl bg-gradient-to-br from-green-100 to-violet-100">

    <h3 className="mb-5 font-bold tracking-widest text-gray-800 uppercase text-small">
      Course Summary
    </h3>

    <div className="grid grid-cols-3 gap-6 text-sm">

      <Info label="Course Name" value={course.CourseName} />
      <Info label="Batch" value={`${course.BatchName} (${course.BatchType})`} />
      <Info label="Timing" value={course.CourseTiming} />
      <Info label="Start Date" value={formatDate(course.BatchStartDate)} />
      <Info label="End Date" value={formatDate(course.BatchEndDate)} />
      <Info label="Role" value={selectedRole} />

    </div>

  </div>


  {/* ================= SEARCH + TABLE ================= */}
  <div className="mt-8">

    {/* SEARCH */}
    <div className="flex items-center justify-between mb-5">

      <input
        type="text"
        placeholder="Search by email..."
        value={searchEmail}
        onChange={(e) => setSearchEmail(e.target.value)}
        className="px-4 py-2 text-sm transition bg-white border border-indigo-200 rounded-lg w-80 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
      />

      <span className="text-sm font-medium text-indigo-600">
        {filteredUsers.length} Users
      </span>

    </div>

    {/* TABLE */}
    <Table
      rowKey="Email"
      bordered={false}
      pagination={{ pageSize: 8 }}
      dataSource={filteredUsers}

      rowSelection={{
        selectedRowKeys,
        onChange: (keys) => setSelectedRowKeys(keys),
      }}

      onRow={(record) => ({
        onClick: () => {
          const isSelected = selectedRowKeys.includes(record.Email);

          if (isSelected) {
            setSelectedRowKeys(
              selectedRowKeys.filter((key) => key !== record.Email)
            );
          } else {
            setSelectedRowKeys([...selectedRowKeys, record.Email]);
          }
        },
      })}

      rowClassName={(record) =>
        selectedRowKeys.includes(record.Email)
          ? "bg-gradient-to-r from-indigo-50 to-violet-50 cursor-pointer"
          : "hover:bg-indigo-50/40 cursor-pointer"
      }

      columns={[
        {
          title: "Full Name",
          dataIndex: "FullName",
        },
        {
          title: "Email",
          dataIndex: "Email",
          render: (text) => (
            <span className="font-medium text-indigo-800">
              {text}
            </span>
          ),
        },
        {
          title: "Phone",
          dataIndex: "PhoneNumber",
        },
        {
          title: "Role",
          dataIndex: "Role",
          render: (text) => (
            <span className="px-2 py-1 text-xs font-semibold rounded-md text-violet-700 bg-violet-100">
              {text}
            </span>
          ),
        },
        {
          title: "Status",
          render: (_, record) => {
            const status =
              record.StudentStatus ||
              record.InstructorStatus ||
              record.OperationsStatus;

            return (
              <span
                className={`px-3 py-1 text-xs font-semibold rounded-full ${
                  status === "ACTIVE"
                    ? "bg-emerald-100 text-emerald-700 border border-emerald-300"
                    : "bg-red-100 text-red-700 border border-red-300"
                }`}
              >
                {status || "N/A"}
              </span>
            );
          },
        },
      ]}
    />

  </div>


  {/* ================= FOOTER ================= */}
  <div className="flex justify-end gap-4 pt-6 mt-8 border-t border-indigo-100">

    <button
      onClick={() => {
        setIsAccessModalOpen(false);
        setSelectedRowKeys([]);
      }}
      className="px-6 py-2 text-sm font-medium text-indigo-600 transition border border-indigo-200 rounded-lg hover:bg-indigo-50"
    >
      Cancel
    </button>

    <button
      onClick={handleSubmitAccess}
      disabled={!selectedRowKeys.length}
      className={`px-6 py-2 text-sm font-semibold rounded-lg transition shadow-sm ${
        selectedRowKeys.length
          ? "bg-gradient-to-r from-indigo-600 to-violet-600 text-white hover:opacity-90"
          : "bg-slate-200 text-slate-400 cursor-not-allowed"
      }`}
    >
      Assign Access
    </button>

  </div>

</Modal>

  </div>
);
}

/* ================= REUSABLE COMPONENTS ================= */

function AnalyticsCard({ title, value }) {
  return (
    <div className="p-6 bg-gray-300 shadow rounded-2xl">
      <div className="text-sm text-gray-900 uppercase">
        {title}
      </div>
      <div className="mt-2 text-xl font-semibold text-gray-900">
        {value}
      </div>
    </div>
  );
}

function TimelineItem({ label, value }) {
  return (
    <div>
      <div className="text-sm text-gray-500 uppercase">
        {label}
      </div>
      <div className="mt-2 text-lg font-semibold text-gray-900">
        {value}
      </div>
    </div>
  );
}

function AccessSection({ title = "", users = [], onDelete,onAdd }) {

  const roleStyles = {
    STUDENT: {
      title: "text-emerald-400",
      addBtn: "bg-emerald-600 hover:bg-emerald-500"
    },
    INSTRUCTOR: {
      title: "text-indigo-400",
      addBtn: "bg-indigo-600 hover:bg-indigo-500"
    },
    OPERATIONS: {
      title: "text-orange-400",
      addBtn: "bg-orange-600 hover:bg-orange-500"
    }
  };

  // Normalize title
  const normalizedTitle = title.toUpperCase();

  // Fallback style (prevents crash)
  const style = roleStyles[normalizedTitle] || {
    title: "text-slate-400",
    addBtn: "bg-slate-600 hover:bg-slate-500"
  };

  return (
    <div className="p-6 border shadow-lg bg-slate-950 border-slate-800 rounded-2xl">

      {/* HEADER */}
      <div className="flex items-center justify-between mb-6">
        <h3 className={`text-small font-semibold tracking-widest uppercase ${style.title}`}>
          {title}
        </h3>

        <button
  onClick={() => onAdd(title)}
  className={`px-4 py-2 text-xs font-semibold text-white rounded-lg transition ${style.addBtn}`}
>
  + ADD {title}
</button>
      </div>

      {/* USERS LIST */}
      <div className="space-y-3 max-h-[300px] overflow-y-auto pr-1">

        {users.length === 0 ? (
          <p className="text-sm text-slate-500">No users added</p>
        ) : (
          users.map((user) => (
            <div
              key={user.Email}
              className="flex items-center justify-between p-4 transition border rounded-xl bg-slate-900 border-slate-800 hover:bg-slate-800"
            >
              <div className="flex gap-6">
                <p className="text-sm font-medium text-white">
                  {user.FullName}
                </p>
                <p className="text-yellow-400 text-medium">
                  {user.Email}
                </p>
              </div>

              <div className="flex items-center gap-3">

                <span
                  className={`px-3 py-1 text-xs font-medium rounded-md ${
                    user.CourseAccess === "ACTIVE"
                      ? "bg-emerald-900/40 text-emerald-400 border border-emerald-700"
                      : "bg-red-900/40 text-red-400 border border-red-700"
                  }`}
                >
                  {user.CourseAccess}
                </span>

                <button
                  onClick={() => onDelete(user)}
                  className="px-3 py-1 text-xs font-semibold text-red-400 transition border border-red-700 rounded-md bg-red-900/30 hover:bg-red-800/40"
                >
                  Delete
                </button>

              </div>
            </div>
          ))
        )}

      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="font-semibold tracking-wide text-indigo-500 uppercase text-small">
        {label}
      </p>
      <p className="mt-1 font-semibold text-indigo-900">
        {value}
      </p>
    </div>
  );
}
export default CourseDetailsInstructor;